<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">Gangs of America</h1>
<h1 class="subtitle">The Rise of Corporate Power and the Disabling of Democracy</h1><br/>
<div class="image"><img alt="image" src="images/0001a.jpg"/></div><br/>
<h2 class="author">Ted Nace</h2><br/><br/><br/><br/>
<div class="image"><img alt="image" src="images/0001.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?349ba29d